
































import Vue from 'vue'
import { makeUniGoods } from '@/utils'

export default Vue.extend({
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    noLazyLoad: {
      type: Boolean,
      default: true,
    },
    noBottomRadius: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    goods() {
      return makeUniGoods(this.item)
    },
  },
})
